const loadResource =
  process.env.VUE_APP_API_ENDPOINT +
  "/enterprises/manning/vessels/crews/scheduler/crew";
const syncResource =
  process.env.VUE_APP_API_ENDPOINT +
  "/enterprises/manning/vessels/crews/scheduler/crew/events";

const headers = {
  tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
  locale: window.navigator.language,
};

export default {
  load: {
    url: loadResource,
    headers: headers,
  },
  sync: {
    url: syncResource,
    headers: headers,
  },
};
